export const WORKSPACE_NAV_PRIMARY = [
  { key: 'ws-marketplace', label: 'AI/ML Marketplace', path: '/workspace/marketplace' },
  { key: 'ws-dataset-search', label: 'Dataset Search', path: '/workspace/dataset-search' },
  { key: 'ws-workflow-creator', label: 'Workflow Creator', path: '/workspace/workflow-creator' },
  { key: 'ws-workflow-editor', label: 'Workflow Editor', path: '/workspace/workflow-editor' },
];

export const WORKSPACE_NAV_VISUALIZATION = [
  { key: 'ws-data-visualization', label: 'Data Visualization', path: '/workspace/data-visualization' },
  { key: 'ws-map-visualization', label: 'Map Visualization', path: '/workspace/map-visualization' },
  { key: 'ws-xr-vr', label: 'XR/VR', path: '/workspace/xr-vr' },
];

// Keep for route->menu key mapping
export const WORKSPACE_NAV_ITEMS = [...WORKSPACE_NAV_PRIMARY, ...WORKSPACE_NAV_VISUALIZATION, { key: 'ws-file-explorer', label: 'File Explorer', path: '/workspace/file-explorer' }];

export const ROUTE_MENU_KEYS = {
  '/': '1',
  '/home': '1',
  '/console': '20',
  '/history': '3',
  '/account': 'account',
  '/user-guides': '19',
  '/preferences': '2',
  '/countdown': '20',
  ...Object.fromEntries(WORKSPACE_NAV_ITEMS.map((item) => [item.path, item.key])),
};

export const getMenuKeyForPath = (pathname) => {
  if (ROUTE_MENU_KEYS[pathname]) return ROUTE_MENU_KEYS[pathname];
  const workspaceMatch = WORKSPACE_NAV_ITEMS.find((item) => pathname.startsWith(item.path));
  if (workspaceMatch) return workspaceMatch.key;
  return '1';
};
